import * as React from 'react';
import { useInView } from 'react-intersection-observer';

import { ActionButton } from './components/ActionButton';
import { BrandImage } from './components/BrandImage';
import { Description } from './components/Description';
import { Title } from './components/Title';
import { useHairAnalyzerBrandData } from './hooks/useHairAnalyzerBrandData';
import { HAIR_ANALYZER_OPEN_HASH } from './lib/constants';
import { useInitHairAnalyzer } from './lib/hooks/useInitHairAnalyzer';
import { trackViewOrSelectPromotion } from './lib/tracking';
import { DescriptionAndActionWrapper, HairAnalyserWrapper } from './styled';

const HairAnalyser = () => {
  const { inView, ref } = useInView();

  const brand = useHairAnalyzerBrandData();

  useInitHairAnalyzer({ brand });

  const hasTrackedImpression = React.useRef(false);

  React.useEffect(() => {
    if (!inView || hasTrackedImpression.current) {
      return;
    }

    trackViewOrSelectPromotion(brand.brandName, 'view_promotion');
    hasTrackedImpression.current = true;
  }, [inView, brand.brandName]);

  const onOpenHairAnalyzer = () => {
    trackViewOrSelectPromotion(brand.brandName, 'select_promotion');
    // Setting the hash is what opens the tool - initRevieve listens for it.
    window.location.hash = HAIR_ANALYZER_OPEN_HASH;
  };

  return (
    <HairAnalyserWrapper
      ref={ref}
      onClick={onOpenHairAnalyzer}
      data-testid="hairAnalyser"
    >
      <BrandImage banner={brand.banner} />

      <DescriptionAndActionWrapper>
        <Title />

        <Description brandName={brand.brandName} />

        <ActionButton onOpenHairAnalyzer={onOpenHairAnalyzer} />
      </DescriptionAndActionWrapper>
    </HairAnalyserWrapper>
  );
};

export default HairAnalyser;
